import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setListing } from "../actions/listing";
import { deleteListing } from "../actions/listing";
// import { getListings } from "../actions/listing";
import setAuthToken from "../utils/setAuthToken";

const MyListingsCard = ({
  listings,
  setListing,
  deleteListing,
  getListings,
}) => {
  const setList = (id) => {
    setListing(id);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setAuthToken(localStorage.token);
    deleteListing(id);
    getListings();
  };

  const { photo_url, name, price, id, stock } = listings;

  return (
    <div className='card text-center'>
      <img
        src={photo_url}
        className='square-img'
        style={{ width: "60px" }}
        alt={name}
      />
      <h3>{name}</h3>
      <h4>${price}</h4>
      <div>
        <Link
          to={`/edit-listing/${id}`}
          onClick={() => setList(id)}
          className='btn btn-dark btn-sm my-1'
        >
          Edit Listing
        </Link>
        <Link
          to={`my-listings`}
          onClick={handleDelete}
          className='btn btn-dark btn-sm my-1'
        >
          Delete Listing
        </Link>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  listings: state.listing.listings,
});

export default connect(null, { setListing, deleteListing })(MyListingsCard);
